/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Goals_QuestionInputs */

const en_onboarding_goals_question = /** @type {(inputs: Onboarding_Goals_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select what you want out of Listening`)
};

const es_onboarding_goals_question = /** @type {(inputs: Onboarding_Goals_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecciona lo que quieres de Listening`)
};

/**
* | output |
* | --- |
* | "Select what you want out of Listening" |
*
* @param {Onboarding_Goals_QuestionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_goals_question = /** @type {((inputs?: Onboarding_Goals_QuestionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Goals_QuestionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_goals_question(inputs)
	return en_onboarding_goals_question(inputs)
});